import { useContext, useState } from 'react'
import { SettingsSuggest } from '@mui/icons-material'
import { NotificationBanner, RegistrationSearchForm } from '../../component/component'
import { generateBulkReports } from '../../service/Service'
import { AppContext } from '../../store/AppProvider'
import { SHOW_ERROR_ALERT } from '../../store/reducer/AlertNotifierReducer'
import { SHOW_SUCCESS_BANNER } from '../../store/reducer/NotificationBannerReducer'
import { scrollToElement } from '../../utils/Utils'
import { ErrorConstant } from '../../utils/Constants'

export const GenerateBulkReport = () => {
    const { setShowBanner, setAlert } = useContext(AppContext)

    const [showLoading, setShowLoading] = useState(false)

    const onSearch = async (formData) => {
        try {
            setShowLoading(true)
            setTimeout(() => {
                setShowLoading(false)
                setShowBanner({ type: SHOW_SUCCESS_BANNER, bannerMessage: 'Report is being Generated. Please check View Bulk Report section to download the CSV.' })
                scrollToElement('notification')
            }, 5000);
            //user should not wait for this response
            await generateBulkReports(formData);
        } catch (error) {
            //bypassing 504 error as by time lambda will be already invoked
            if (error?.code !== 'ERR_NETWORK') {
                setAlert({ type: SHOW_ERROR_ALERT, alertMessage: ErrorConstant.generatingCSV })
            }
        }
    }

    return (
        <div>
            <div className='header-title' style={{ letterSpacing: '0.5px' }}>GENERATE BULK REPORTS</div>
            <RegistrationSearchForm
                showPopField={false}
                loading={showLoading}
                buttonText={"Generate Report"}
                buttonIcon={<SettingsSuggest />}
                maxPurchaseDateMonthCount={2}
                maxWarrantyDateMonthCount={2}
                maxRegDateMonthCount={2}
                onSearch={(formData) => onSearch(formData)} />
            <div id='notification'>
                <NotificationBanner />
            </div>
        </div>
    )
}
